import LegalPage from './LegalPage';
const CookiePolicy = () => <LegalPage pageKey="cookies" />;
export default CookiePolicy;
